const MockData = {
  "people": [
    {
      "id": 1,
      "active": true,
      "type": "מועמד",
      "name": "טלי פרוס",
      "organisation": "Google",
      "job": "מפתחת",
      "gender": "נקבה",
      "tribe": "חילוני",
      "city": "Tel-Aviv",
      "sector": "מגזר עסקי",
      "phone": "054-219-7723"
    },
    {
      "id": 2,
      "active": true,
      "type": "מועמד",
      "evaluatorType": "מעוז",
      "name": "דורין אליהו",
      "organisation": "Moovit",
      "job": "מפתחת",
      "gender": "נקבה",
      "tribe": "דתייה",
      "sector": "מגזר חברתי",
      "phone": "054-219-7723"
    }
  ],
  "evaluaters": [
    {
      "id": 1,
      "active": true,
      "type": "מועמד",
      "name": "ספיר שמון",
      "organisation": "Google",
      "job": "מפתחת",
      "gender": "נקבה",
      "tribe": "חילוני",
      "city": "Tel-Aviv",
      "sector": "מגזר ממשלתי",
      "phone": "054-219-7723"
    },
    {
      "id": 2,
      "active": true,
      "type": "מועמד",
      "evaluatorType": "מעוז",
      "name": "גיא וולדמן",
      "organisation": "PayPal",
      "job": "מפתחת",
      "gender": "זכר",
      "tribe": "דתייה",
      "sector": "מגזר עסקי",
      "phone": "054-219-7723"
    }
  ],
  "notes": [
    {
      "person": 1,
      "note": "This is my note"
    }
  ]
};

export default MockData;